import script from "./TBPhysicianSchedule.vue?vue&type=script&setup=true&lang=js"
export * from "./TBPhysicianSchedule.vue?vue&type=script&setup=true&lang=js"

import "./TBPhysicianSchedule.vue?vue&type=style&index=0&id=0d2f5ffc&lang=css"

const __exports__ = script;

export default __exports__